import { motion } from "framer-motion";

const AboutAchievements = ({ stats }) => {
    return (
        <section className="py-20 bg-gradient-to-r from-[#0c2c4d] to-[#082f49] text-white">
            <div className="max-w-6xl mx-auto px-6 text-center">
                <h2 className="text-4xl md:text-5xl font-extrabold mb-6">
                    Thành tựu nổi bật
                </h2>

                <p className="text-lg md:text-xl mb-12">
                    Mỹ Diệp đã đạt được nhiều thành công trong lĩnh vực bất động sản.
                </p>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    {stats.map((item, index) => (
                        <motion.div
                            key={item.label}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{
                                opacity: 1,
                                y: 0,
                            }}
                            transition={{
                                duration: 0.6,
                                delay: index * 0.2,
                            }}
                            className="bg-white/10 backdrop-blur-md rounded-xl py-6"
                        >
                            <div className="text-yellow-400 text-3xl font-bold">
                                {item.value}
                            </div>

                            <div className="mt-2">
                                {item.label}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AboutAchievements;